module.exports = __webpack_public_path__ + "img/azure_drake_small.491a562f.png";